// Données structurées JSON-LD (Bloc P1.4). Lecture depuis la source unique.
import { SITE_URL } from "./routes-meta";
import { fr } from "../content/fr";

export const CONTACT_EMAIL = "hello@viralya.io";

const PLANS = [
  { nom: "Starter", prix: "197" },
  { nom: "Growth", prix: "497" },
  { nom: "Brand", prix: "797" },
  { nom: "Agency", prix: "2197" },
  { nom: "Marque Blanche", prix: "3497" },
];

export const orgLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "VIRALYA",
  legalName: "Homely Solutions Sàrl",
  url: SITE_URL,
  logo: SITE_URL + "/icon-512.png",
  email: CONTACT_EMAIL,
  description:
    "Studio d'influenceurs IA en Suisse romande : création du personnage (visage, voix, marque) et pilotage de la publication quotidienne sur 4 plateformes.",
  areaServed: "CH",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Rue Jean André Venel 4",
    addressLocality: "Yverdon-les-Bains",
    postalCode: "1400",
    addressCountry: "CH",
  },
  contactPoint: {
    "@type": "ContactPoint",
    email: CONTACT_EMAIL,
    contactType: "customer support",
    availableLanguage: ["fr"],
  },
};

export const serviceLd = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "VIRALYA — Studio d'influenceurs IA",
  serviceType: "Création et pilotage d'influenceurs IA",
  provider: { "@type": "Organization", name: "VIRALYA", url: SITE_URL },
  areaServed: "CH",
  url: SITE_URL + "/prix",
  description:
    "Un influenceur IA qui publie, répond et prospecte chaque jour sur 4 plateformes.",
  offers: PLANS.map((p) => ({
    "@type": "Offer",
    name: p.nom,
    price: p.prix,
    priceCurrency: "CHF",
    url: SITE_URL + "/prix",
    availability: "https://schema.org/InStock",
    priceSpecification: {
      "@type": "UnitPriceSpecification",
      price: p.prix,
      priceCurrency: "CHF",
      unitText: "MONTH",
      billingIncrement: 1,
    },
  })),
};

export const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: fr.faq.items.map((it) => ({
    "@type": "Question",
    name: it.q,
    acceptedAnswer: { "@type": "Answer", text: it.a },
  })),
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: SITE_URL + it.path,
  })),
});
